export default __webpack_public_path__ + "static/media/blog_inner_21.e033b877.png";